/*
 * Purpose: Admin sub-navigation — overview, analytics, AI, engineer
 * Last modified: 2026-06-28 | Agent
 * Completeness: 94
 */
import { Link, useLocation } from 'react-router-dom';
import { APP_ROUTES } from '@/lib/appRoutes';
import { cn } from '@/lib/utils';

const ADMIN_TABS = [
  { id: 'overview', label: 'Overview', href: APP_ROUTES.admin },
  { id: 'analytics', label: 'Analytics', href: APP_ROUTES.adminAnalytics },
  { id: 'ai', label: 'AI insights', href: APP_ROUTES.adminAiInsights },
  { id: 'engineer', label: 'Work Engineer', href: APP_ROUTES.adminEngineer },
] as const;

export function AdminSubNav() {
  const { pathname } = useLocation();

  return (
    <nav
      className="flex gap-1 overflow-x-auto px-4 sm:px-6 py-2 border-b border-border/40 bg-muted/20"
      aria-label="Admin"
    >
      {ADMIN_TABS.map((tab) => {
        const active =
          tab.href === APP_ROUTES.admin
            ? pathname === APP_ROUTES.admin
            : pathname.startsWith(tab.href);
        return (
          <Link
            key={tab.id}
            to={tab.href}
            className={cn(
              'shrink-0 px-3 py-1.5 rounded-md text-xs sm:text-sm font-medium transition-colors',
              active
                ? 'bg-[hsl(var(--ab-green-core)/0.12)] text-[hsl(var(--ab-green-deep))]'
                : 'text-muted-foreground hover:text-foreground hover:bg-muted/60'
            )}
          >
            {tab.label}
          </Link>
        );
      })}
    </nav>
  );
}
